import React, { useState, useEffect } from 'react';

const CategoryBar = ({ label, value, max = 100 }) => {
    const [width, setWidth] = useState(0);
    const target = (value / max) * 100;

    useEffect(() => {
        const timer = setTimeout(() => setWidth(target), 700);
        return () => clearTimeout(timer);
    }, [target]);

    return (
        <div className="clinic-dashboard-catbar">
            <span className="clinic-dashboard-catbar-label">{label}</span>
            <div className="clinic-dashboard-catbar-track">
                <div
                    className="clinic-dashboard-catbar-fill"
                    style={{ width: `${width}%`, transition: 'width 1s cubic-bezier(0.4, 0, 0.2, 1)' }}
                />
            </div>
            <span className="clinic-dashboard-catbar-value">{value}%</span>
        </div>
    );
};

export default CategoryBar;
